import React from 'react';
import Service1 from 'views/Service/Service1';

const LifeSkillPage = () => {
  return <Service1/>;
};

export default LifeSkillPage;